module.exports = __webpack_public_path__ + "assets/img/00167.8699699d.png";